module.exports = __webpack_public_path__ + "static/media/mars5.548733ff.jpg";